import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconDesktopWindowsSvg } from "./IconDesktopWindowsSvg.mjs";
const IconDesktopWindows = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconDesktopWindowsSvg, ...iconProps });
};
export {
  IconDesktopWindows
};
